<template lang="pug">
.container.center-box
  table.table.table-sm
    thead.thead-light
      tr
        th(scope="col") 年度
        th(scope="col") 活動名稱
        th(scope="col") 最後維護日
        th(scope="col") 成果上傳
        th(scope="col") 審核狀態
    tbody
      tr(v-for="e in dataList" :key="e.id")
        td(style="width: 3rem;") {{e.year}}
        td(style="width: 28rem;")  {{e.activity_name}}
        td(style="width: 8rem;") {{e.update_time}}

        td(style="width: 8rem;")
          button.btn.btn-outline-success.bi.bi-cloud-arrow-up.gy(
            v-if="e.canUpload"
            @click="goEditPage('Upload', e.id, e.activity_name)"
            type="button"
          ) 成果上傳
        td(style="width: 8rem;")
          .badge.badge-success(style="width: 6rem;" v-if="e.check_flag && e.final_flag && e.canUpload ") 已結案
          .badge.badge-warning(style="width: 6rem;" v-if="e.check_flag && !e.final_flag") 等待核准
          .badge.badge-info(style="width: 6rem;" v-if="!e.check_flag && !e.final_flag ") 未檢視



  MyPagination(v-bind="pagination" @update:page="setPage")

</template>

<script>
import MyPagination from '@/components/MyPagination'

import { fetchGrantApplicationList } from '@/api/client/Grant'

export default {
  components: { MyPagination },
  data () {
    return {
      u_str: null,
      dataList: [],
      pagination: {
        page: 1,
        max: 1,
        take: 15,
      },
    }
  },
  methods: {
    setPageMax (total) {
      this.pagination.max = Math.ceil(total / this.pagination.take)
    },
    async fetchDataList (page) {
      const now = new Date()
      const { data, total_num } = await fetchGrantApplicationList({
        type: 1, u_str: this.u_str, page
      })
      this.setPageMax(total_num)
      this.dataList = data.map(e => {
        const { check_flag, final_flag, grant_endtime, grant_starttime } = e
        const canUpload = final_flag === 1
        const isTimeOk = new Date(grant_endtime) > now && new Date(grant_starttime) < now
        const canMaintain =[0, 2].includes(check_flag) && isTimeOk
        return {
          ...e,
          canUpload,
          canMaintain
        }
      })
    },
    async setPage (p) {
      this.pagination.page = +p
      await this.fetchDataList(+p)
    },
    async goEditPage(name, id, activity_name) {
      console.log(name, id, activity_name)
      this.$router.push({
        path:'/artedu1872/subsidy/upload',
        query: {id, activity_name}
      })
    }
  },
  async mounted () {
    const user = sessionStorage.getItem('user')  //如果沒登入則回到登入頁面
    console.log(user)
    if (!user) {
      //this.$router.push({ name: 'UploadData'})
      this.$router.push({ path: '/artedu1872/subsidy/loginNow' })
      return
    }
    const { u_str } = JSON.parse(user)
    this.u_str = u_str
    console.log(this.u_str)
    if (!u_str) {
      //this.$router.push({ name: 'UploadData' })
      this.$router.push({ path: '/artedu1872/subsidy/loginNow' })
      return
    }
    await this.fetchDataList(1)
  }
}
</script>

<style lang="sass" scoped>
</style>




// WEBPACK FOOTER //
// src/views/Artedu1872/components/UploadData/MaintanList.vue